import { ConfirmDialog } from "../../ui";

type DeleteReservationDialogProps = {
  reservationId: string;
  isOpen: boolean;
  onDelete: () => Promise<void>;
  onClose: (update?: boolean) => void;
};

/** "Are you sure?" before a reservation is deleted. The parent runs the delete and reports errors. */
const DeleteReservationDialog = (props: DeleteReservationDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={(confirmed) => props.onClose(confirmed || undefined)}
    onConfirm={props.onDelete}
    title="Delete Reservation"
    heading="Are you sure?"
    message="This action cannot be undone. If you delete this reservation, it will be permanently removed."
    confirmLabel="Delete"
    tone="danger"
  />
);

export default DeleteReservationDialog;
